var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowSlideIcon = function SvgArrowSlideIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM35.1949 22.4031L44.5844 31.5192C44.8533 31.7799 45.0008 32.1285 45 32.5002C45.0011 32.8706 44.8533 33.2191 44.5846 33.4801L35.1951 42.5961C34.9271 42.8563 34.5699 43 34.1889 43C33.8076 43 33.4506 42.8582 33.1826 42.598L32.3301 41.7728C32.0622 41.5128 31.9147 41.1702 31.9147 40.8006C31.9147 40.4306 32.0622 40.093 32.3301 39.8328L37.8697 34.4732H20.4046C19.62 34.4732 19 33.8167 19 33.0547V31.8843C19 31.1223 19.62 30.526 20.4046 30.526H37.8076L32.3299 25.1961C32.062 24.9363 31.9145 24.5776 31.9145 24.2078C31.9145 23.8378 32.062 23.4907 32.3299 23.2309L33.1824 22.4031C33.4504 22.143 33.8074 22 34.1887 22C34.5696 22 34.9269 22.1428 35.1949 22.4031Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowSlideIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_slide_icon.081c02e2.svg";
export { ForwardRef as ReactComponent };